import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

export interface PeriscopeTablessContentProps {
	className?: string;
}

export const PeriscopeTablessContent: React.FC<PropsWithChildren<PeriscopeTablessContentProps>> = ({
	children,
	className = ''
}) =>
	<div className={ classNames('periscope-content-tabless', className) }>{ children }</div>;

